import React from 'react';
import { observer } from 'mobx-react';
const TreeRuler = observer(({ model }) => {
    const { treeAreaWidth } = model;
    return React.createElement("div", { style: { flexShrink: 0, width: treeAreaWidth } });
});
export default TreeRuler;
//# sourceMappingURL=TreeRuler.js.map